import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { NoticeUI } from './ui';

export class Notice extends PureComponent {
    static displayName = 'NoticeContainer';

    render() {
        const { ...rest } = this.props;

        // PUT OTHER PROPS AFTER {...rest}
        return <NoticeUI {...rest} />;
    }
}

export const NoticeContainer = compose()(Notice);
